import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const domain = window.location.hostname
  .split('.')
  .splice(-2)
  .join('.')

const isProduction = domain === 'krolewskie.pl'

export default new Vuex.Store({
  state: {
    isMobileMenuOpen: false,
    isCookiesOpen: false,
    isGateOpen: true,
    activePopup: '',
    healthPopup: true,
    currentSlide: 0,
    lastClientX: 0,
    initSlideIdxFromUrlOnDesktop: 0,
    loaderProgress: 0,
    mainMetaDescription:
      'Królewskie Jasne Pełne to piwo o prawdziwie warszawskich korzeniach. Łączy w sobie warszawski charakter i królewski pełny smak',
    sections: [
      {
        name: 'loteria',
        slug: 'loteria',
        title: 'Loteria',
        subtitle: 'Wygraj <br> 4-pak lub Piwo',
        navTitle: 'Loteria',
        linkTitle: 'Dowiedz się więcej',
        link: isProduction
          ? 'https://loteria.krolewskie.pl/?ref=1'
          : `https://krolewskie-loteria-2025.${domain}`,
        animation: 'double',
        metaDescription:
          'Ruszyła loteria Królewskiego. Szukaj w sklepach promocyjnych opakowań. Sprawdzaj kody pod kapslami lub zawleczką. Graj o koszulkę meczową Legii lub piwo!',
        mainNav: {
          title: 'Loteria'
        },
        images: [
          '/images/sections/loteria-kapsle2026.png',
          '/images/sections/loteria-piwo2026.png'
        ],
        mobileImage: ['/images/sections-mobile/loteria2026.png']
      },
      {
        name: 'smak',
        slug: 'tak-smakuje-warszawa',
        title: 'Tak smakuje',
        subtitle: 'Warszawa',
        navTitle: 'Tak Smakuje Warszawa',
        linkTitle: 'Przejdź do youtube',
        link: 'https://www.youtube.com/watch?v=H1wh9grP83c',
        animation: 'single',
        metaDescription:
          'Królewskie Jasne Pełne to piwo o prawdziwie warszawskich korzeniach. Łączy w sobie warszawski charakter i królewski pełny smak.',
        mainNav: {
          title: 'Tak smakuje',
          subtitle: 'Warszawa'
        },
        images: ['/images/sections/smak.svg'],
        mobileImage: '/images/sections-mobile/smak.png'
      },
      {
        name: 'jasne',
        slug: 'piwo-jasne-pelne',
        title: 'królewskie',
        subtitle: 'jasne pełne',
        navTitle: 'Jasne Pełne',
        linkTitle: 'jasne',
        link: '',
        reverseTitleColors: true,
        animation: 'double',
        metaDescription:
          'Królewskie Jasne Pełne to piwo o prawdziwie warszawskich korzeniach. Łączy w sobie warszawski charakter i królewski pełny smak.',
        mainNav: {
          title: 'jasne pełne'
        },
        images: [
          '/images/sections/jasne-1.png',
          '/images/sections/jasne-2.png'
        ],
        mobileImage: '/images/sections-mobile/jasne.png'
      }
    ]
  },
  getters: {
    sections: state => {
      return state.sections.map((section, idx) => {
        return {
          ...section,
          isActiveSection: state.currentSlide === idx + 1,
          isActiveSectionMobile: state.currentSlide === idx + 2
        }
      })
    },
    getSectionIdxBySlug: state => {
      return slug => state.sections.findIndex(section => section.slug === slug)
    },
    isPageLoaded: state => {
      return state.loaderProgress === 100
    },
    startingPage: state => {
      return state.loaderProgress === 100 && !state.isGateOpen
    },
    isAnyPopupOpen: state =>
      state.activePopup ||
      state.isMobileMenuOpen ||
      state.isCookiesOpen ||
      state.isGateOpen
  },
  mutations: {
    toggleMobileMenu(state) {
      state.isMobileMenuOpen = !state.isMobileMenuOpen
    },
    toggleCookies(state) {
      state.isCookiesOpen = !state.isCookiesOpen
    },
    toggleGate(state) {
      state.isGateOpen = !state.isGateOpen
    },
    togglePopup(state, name) {
      state.activePopup = state.activePopup === name ? '' : name
    },
    setCurrentSlide(state, nr) {
      state.currentSlide = nr
    },
    updateLastClientX(state, value) {
      state.lastClientX = value
    },
    updateInitialSlide(state, idx) {
      state.initSlideIdxFromUrlOnDesktop = idx
    },
    setLoadedProgress(state, number) {
      state.loaderProgress = number
    }
  }
})
